import React from 'react';
import { Card } from '@mui/material';
import PreviewImage from './PreviewImage';
import { getFileUploadUrl } from '../../project/project.api';
import { toast } from 'react-toastify';

interface ReadOnlyCoverImageProps {
  previewBlobName: string | null;
  coverImageBlobName?: string | null;
}

const ReadOnlyCoverImage: React.FC<ReadOnlyCoverImageProps> = ({ previewBlobName, coverImageBlobName }) => {
  const showOriginalImage = async () => {
    if (coverImageBlobName) {
      const url = await getFileUploadUrl(coverImageBlobName);
      window.open(url, '_blank');
    } else if (previewBlobName) {
      const url = await getFileUploadUrl(previewBlobName);
      window.open(url, '_blank');
    } else {
      toast.error('No cover image available.');
    }
  };

  return (
    <Card sx={{ position: 'relative', height: '100%', overflow: 'hidden' }}>
      <PreviewImage blobName={previewBlobName} onClick={showOriginalImage} alt='Project cover image' sx={{ cursor: 'pointer' }} />
    </Card>
  );
};

export default ReadOnlyCoverImage;
